import axios from "axios";

export default async function editAdminUser(user, { ...args }) {
    await axios.patch(`/admin-dashboard/user/${user}/edit`, { ...args })
}